import { connect } from 'react-redux';
import AlertDialog from 'Components/AlertDialog/AlertDialog';
import getAlertDialogProps from 'Components/AlertDialog/AlertDialogSelector';

const mapStateToProps = state => getAlertDialogProps(state);

export default connect(mapStateToProps)(AlertDialog);
